import { LifespanProjectionBase } from './base/lifespan-projection-base';

export class LifespanProjection extends LifespanProjectionBase { }